import React from 'react';
import RemindersActionBar from './reminders-action-bar-view';

type RemindersActionBarContainerProps = {
  onNewReminder: () => void;
};

const RemindersActionBarContainer = ({
  onNewReminder,
}: RemindersActionBarContainerProps) => (
  <RemindersActionBar onNewReminder={onNewReminder} />
);

export default RemindersActionBarContainer;
